import axios, { AxiosResponse } from 'axios';

const C6PdfApi = (idzad: string | number, fileName: string, lang: string) => {
    return axios({
        method: 'GET',
        url: `/AML/${idzad}/c6/pdfdownload`,
        params: {
            jazyk: lang
        },
        responseType: 'blob' // important
    }).then(resp => {
        if (resp.status === 200) {
            // způsob, jak stažený dokument otevřít v browseru
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const nav = window.navigator as any;
            // IE
            if (nav?.msSaveOrOpenBlob) {
                nav.msSaveOrOpenBlob(resp.data, fileName);
            } else {
                const odp = resp.data;

                const uriContent = URL.createObjectURL(
                    new Blob([odp], {
                        type: 'application/octetstream'
                    })
                );
                const link = document.createElement('a');
                link.style.display = 'none';
                link.download = fileName;
                link.href = uriContent;
                link.target = '_blank';
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            }
        }
    });
};

export const C6BisignApi = (idzad: string | number, lang: string) => {
    return axios({
        method: 'PUT',
        url: `/AML/${idzad}/c6/pdfbisign`,
        data: {
            jazyk: lang
        }
    }).then((resp: AxiosResponse<{ redirect: string }>) => resp.data);
};

export default C6PdfApi;
